import { render, staticRenderFns } from "./BxHeader.vue?vue&type=template&id=9f95ce92&"
import script from "./BxHeader.vue?vue&type=script&lang=js&"
export * from "./BxHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports